import { Component, inject } from '@angular/core';
import { LocalizationService } from '../../core/localization/localization.service';
import { InfoHintComponent } from '../../shared/design-system/info-hint.component';

@Component({
  standalone: true,
  selector: 'ain-catalog-products-media-panel',
  imports: [InfoHintComponent],
  template: `
    <ain-info-hint
      [titleKey]="'catalog.products.hub.media.hint.title'"
      [descriptionKey]="'catalog.products.hub.media.hint.description'"
      [bulletKeys]="[
        'catalog.products.hub.media.hint.bullets.perOffering',
        'catalog.products.hub.media.hint.bullets.primary'
      ]" />
    <p class="note">{{ t('catalog.products.hub.media.note') }}</p>
  `,
  styles: [`
    .note { margin: 12px 0 0; color: #475569; font-size: 14px; line-height: 1.5; }
  `]
})
export class CatalogProductsMediaPanelComponent {
  private readonly localization = inject(LocalizationService);

  t(key: string): string {
    return this.localization.translate(key);
  }
}
